
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import GTag from '../components/GTag';
function Vimannagarpunetaxi() {



    const cardData =
    {
        keyword: ' Viman Nagar Pune Taxi',
        heading: 'Mauli Cabs:  Viman Nagar Pune Taxi',
        headingDescription: 'Mauli Cabs offers reliable and comfortable taxi services in Viman Nagar, Pune, ensuring a convenient and hassle-free travel experience. Whether you are heading to the airport, going for a business meeting, or exploring the local area, we provide a wide range of vehicles including sedans, SUVs, and premium cabs to fit your requirements. With professional drivers, transparent pricing, no hidden charges, and a strong focus on punctuality and customer satisfaction, Mauli Cabs guarantees a smooth and enjoyable ride within and around Viman Nagar.',

        top: 'Top Places to Visit in Pune with Mauli Cabs',

"topPlaces": [
    {
        "title": "Shaniwar Wada",
        "description": "A historic fortification in the heart of Pune, Shaniwar Wada was the seat of the Peshwas of the Maratha Empire and is known for its majestic architecture and legends."
    },
    {
        "title": "Aga Khan Palace",
        "description": "Built in 1892, the Aga Khan Palace is a beautiful monument of national importance, known for its connection to Mahatma Gandhi and India's freedom movement."
    },
    {
        "title": "Sinhagad Fort",
        "description": "Located around 30 km from Pune, Sinhagad Fort is a popular trekking spot with rich historical significance and panoramic views of the Sahyadri hills."
    },
    {
        "title": "Pataleshwar Cave Temple",
        "description": "An 8th-century rock-cut temple carved out of a single basalt rock, Pataleshwar Cave Temple is dedicated to Lord Shiva and offers a peaceful spiritual retreat."
    },
    {
        "title": "Dagdusheth Halwai Ganpati Temple",
        "description": "One of the most famous Ganpati temples in Maharashtra, this temple is known for its rich history, beautiful idol, and grand Ganesh Chaturthi celebrations."
    },
    {
        "title": "Raja Dinkar Kelkar Museum",
        "description": "This museum houses an impressive collection of over 20,000 artifacts showcasing Indian arts, crafts, and culture, curated by Dr. Dinkar Kelkar."
    },
    {
        "title": "Parvati Hill and Temple",
        "description": "Parvati Hill is one of the oldest heritage sites in Pune, offering a temple complex atop a hill with stunning views of the city."
    },
    {
        "title": "Osho Ashram",
        "description": "Located in Koregaon Park, Osho Ashram is a spiritual retreat offering meditation programs and a serene environment, attracting visitors from around the world."
    },
    {
        "title": "Pune Okayama Friendship Garden",
        "description": "Also known as Pu La Deshpande Garden, this is a Japanese-style landscape garden perfect for relaxing walks and photography."
    },
    {
        "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
        "description": "This zoo and snake park features a wide variety of reptiles and animals, making it a favorite spot for families and children."
    }
],

"services": [
    {
      "name": "Car Rental Agency in Viman Nagar Pune",
      "description": "Find the most reliable car rental agencies in Viman Nagar, Pune offering chauffeur-driven and self-drive options for local and outstation travel."
    },
    {
      "name": "Innova Car Rental in Viman Nagar",
      "description": "Rent a Toyota Innova in Viman Nagar for comfortable city rides or long trips. Spacious interiors and AC comfort make it perfect for family or group travel."
    },
    {
      "name": "Viman Nagar Taxi Service",
      "description": "Book local and outstation taxis from Viman Nagar. Quick availability, professional drivers, and reasonable pricing guaranteed."
    },
    {
      "name": "Taxi Service in Viman Nagar",
      "description": "Reliable taxi services in Viman Nagar for local travel, airport transfers, or long-distance trips. On-time pickup and clean vehicles provided."
    },
    {
      "name": "Best Taxi Service in Viman Nagar Pune",
      "description": "Top-rated taxi service in Viman Nagar with excellent reviews, skilled drivers, and a fleet of well-maintained vehicles for all your travel needs."
    },
    {
      "name": "Best Taxi Service in Viman Nagar",
      "description": "Experience the best-in-class taxi services in Viman Nagar. Book online and enjoy safe, comfortable, and affordable travel within or outside the city."
    },
    {
      "name": "Pune Airport Cab",
      "description": "Quick and reliable cab service to and from Pune Airport. Timely pickup, transparent fares, and clean cars ensure a stress-free airport commute."
    },
    {
      "name": "Pune to Mumbai Airport Cab",
      "description": "Book a one-way or round-trip cab from Pune to Mumbai Airport. Choose from a wide range of vehicles including sedans, SUVs, and luxury cars."
    },
    {
      "name": "Pune to Shirdi Cab One Way",
      "description": "Hire a one-way cab from Pune to Shirdi for a smooth and affordable pilgrimage trip. AC vehicles and experienced drivers provided."
    },
    {
      "name": "Pune to Mumbai Airport",
      "description": "Get seamless travel from Pune to Mumbai Airport with our punctual and reliable cab services. Perfect for business or personal travel."
    },
    {
      "name": "Pune Mumbai Airport Drop",
      "description": "Book a convenient drop taxi from Pune to Mumbai Airport. On-time service with fixed pricing and multiple vehicle options."
    },
    {
      "name": "Pune Airport to Shirdi Taxi",
      "description": "Comfortable and budget-friendly taxis available from Pune Airport to Shirdi. Suitable for solo travelers, families, or small groups."
    },
    {
      "name": "Airport Taxi Pune",
      "description": "Trusted airport taxi service in Pune for pickups and drops. Available 24/7 with trained drivers and GPS-enabled cabs."
    },
    {
      "name": "Airport Drop Pune",
      "description": "Book a quick airport drop from anywhere in Pune. Affordable rates, timely service, and various cab options for every need."
    },
    {
      "name": "Mumbai International Airport to Pune Cab",
      "description": "Hire a cab from Mumbai International Airport to Pune. Hassle-free booking, professional drivers, and sanitized cars ensured."
    },
    {
      "name": "Pune Airport to Shirdi Cab Price",
      "description": "Check and compare prices for Pune Airport to Shirdi cab services. No hidden charges and flexible travel timings available."
    },
    {
      "name": "Airport Cab Service Pune",
      "description": "Premium airport cab services in Pune offering easy booking, instant confirmation, and dependable travel for local and intercity trips."
    },
    {
      "name": "Airport Pickup and Drop Pune",
      "description": "Book cab services in Pune for airport pickups and drops. Timely arrivals, luggage assistance, and courteous chauffeurs provided."
    },
    {
      "name": "Airport Drop Mumbai from Pune",
      "description": "Get a direct cab from Pune to Mumbai Airport with zero hassles. Best for early morning or late-night flights."
    },
    {
      "name": "Airport Taxi Service in Pune",
      "description": "Professional taxi service in Pune for airport travel. On-time arrivals and well-maintained vehicles ensure safe rides."
    },
    {
      "name": "Best Cab Service from Mumbai Airport to Pune",
      "description": "Experience the best-rated cab service for transfers from Mumbai Airport to Pune. Fixed fares and comfortable seating guaranteed."
    },
    {
      "name": "Airport Transfer Pune",
      "description": "Fast and reliable airport transfer services in Pune for both domestic and international terminals. Affordable and convenient rides."
    },
    {
      "name": "Book Airport Cab Pune",
      "description": "Easily book airport cabs in Pune online or via call. Various car categories available for different budgets and group sizes."
    },
    {
      "name": "Book Cab to Pune Airport",
      "description": "Schedule a cab to Pune Airport with real-time tracking and on-time arrival. Ideal for business travelers and families alike."
    },
    {
      "name": "Pune Airport Drop",
      "description": "Dedicated drop service to Pune Airport from any part of the city. Fixed rates and reliable drivers ensure peace of mind."
    },
    {
      "name": "Pune Airport Cab Booking",
      "description": "Book cabs online for Pune Airport travel. Transparent billing, no surge pricing, and courteous service guaranteed."
    },
    {
      "name": "Pune Airport Drop Cab",
      "description": "Affordable and timely drop cab service to Pune Airport. Available in hatchback, sedan, and SUV variants."
    },
    {
      "name": "Pune Airport Drop Cab Service",
      "description": "Premium cab service for Pune Airport drop with on-time pickups and clean, sanitized vehicles. Book now for fixed fare assurance."
    },
    {
      "name": "Pune Airport Drop Charges",
      "description": "Check Pune Airport drop charges based on vehicle type, distance, and time. Transparent and budget-friendly rates available."
    }
  ],
  "tableData": [
    ["Car Rental Agency in Viman Nagar Pune", "Innova Car Rental in Viman Nagar"],
    ["Viman Nagar Taxi Service", "Taxi Service in Viman Nagar"],
    ["Best Taxi Service in Viman Nagar Pune", "Best Taxi Service in Viman Nagar"],
    ["Pune Airport Cab", "Pune to Mumbai Airport Cab"],
    ["Pune to Shirdi Cab One Way", "Pune to Mumbai Airport"],
    ["Pune Mumbai Airport Drop", "Pune Airport to Shirdi Taxi"],
    ["Airport Taxi Pune", "Airport Drop Pune"],
    ["Mumbai International Airport to Pune Cab", "Pune Airport to Shirdi Cab Price"],
    ["Airport Cab Service Pune", "Airport Pickup and Drop Pune"],
    ["Airport Drop Mumbai from Pune", "Airport Taxi Service in Pune"],
    ["Best Cab Service from Mumbai Airport to Pune", "Airport Transfer Pune"],
    ["Book Airport Cab Pune", "Book Cab to Pune Airport"],
    ["Pune Airport Drop", "Pune Airport Cab Booking"],
    ["Pune Airport Drop Cab", "Pune Airport Drop Cab Service"],
    ["Pune Airport Drop Charges", ""]
  ],


"whychoose": [
    {
        "WhyChooseheading": "Convenient and Reliable Taxi Service",
        "WhyChoosedescription": "Mauli Cabs offers reliable and on-time taxi services in Viman Nagar, Pune. Whether you need a quick ride to the airport, a business meeting, or a leisurely outing, we ensure a hassle-free travel experience."
    },
    {
        "WhyChooseheading": "Wide Range of Vehicles Available",
        "WhyChoosedescription": "Choose from a variety of well-maintained vehicles including hatchbacks, sedans, and SUVs for your trip around Viman Nagar. We provide comfortable and spacious options to suit your travel needs."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are professional, courteous, and experienced with local routes. They ensure a safe, comfortable, and timely ride, whether you're traveling to the airport or exploring the local attractions."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Mauli Cabs offers affordable rates for taxi rides within Viman Nagar and beyond. Enjoy transparent pricing with no hidden charges, ensuring you get value for money on every trip."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "Need a taxi at any time of day or night? We are available 24/7 in Viman Nagar, ensuring you always have a taxi ready whenever you need it, whether for early morning or late-night trips."
    },
    {
        "WhyChooseheading": "Easy Booking Process",
        "WhyChoosedescription": "Booking a taxi in Viman Nagar is quick and easy with our user-friendly website and app. You can book a ride in just a few clicks and track your taxi in real-time for added convenience."
    },
    {
        "WhyChooseheading": "Comfortable and Well-Maintained Taxis",
        "WhyChoosedescription": "Our taxis are regularly serviced and cleaned to ensure a smooth and comfortable ride. Enjoy a safe and pleasant experience every time you book a taxi in Viman Nagar."
    },
    {
        "WhyChooseheading": "Perfect for Airport Transfers",
        "WhyChoosedescription": "Traveling to or from Pune Airport? Mauli Cabs offers dedicated airport taxi services in Viman Nagar. We ensure timely pick-up and drop-off to ensure you never miss your flight or have to wait for long."
    }
]






















    }


    const faqData = [
        {
            question: 'How can I book a taxi in Viman Nagar, Pune with Mauli Cabs?',
            answer: 'Booking a taxi in Viman Nagar is simple with Mauli Cabs. Just visit our website or use the mobile app, enter your pickup location as "Viman Nagar" and your destination, select the vehicle type, and confirm your booking. You can also book by calling our support team.',
        },
        {
            question: 'Are taxis available for both local and outstation travel from Viman Nagar?',
            answer: 'Yes, Mauli Cabs offers taxi services for both local Pune travel and outstation trips directly from Viman Nagar. You can choose hourly packages or intercity routes as per your travel need.',
        },
        {
            question: 'What types of vehicles are available in Viman Nagar?',
            answer: 'We offer a range of vehicles in Viman Nagar including Hatchbacks, Sedans, SUVs, Ertiga, Innova Crysta, and premium options. Whether it’s a short city ride or a long-distance journey, we have the right cab for you.',
        },
        {
            question: 'Is Mauli Cabs service available 24/7 in Viman Nagar?',
            answer: 'Yes, our taxi services in Viman Nagar operate round the clock. You can book a cab for early morning airport drops, late-night pickups, or any other time of the day or night.',
        },
        {
            question: 'Can I get a cab on-demand in Viman Nagar?',
            answer: 'Yes, we offer both immediate and advance bookings. For faster service, we recommend booking slightly in advance during peak hours, weekends, or airport rush times.',
        },
        {
            question: 'Do Mauli Cabs drivers know the Viman Nagar area well?',
            answer: 'Absolutely. Our drivers are familiar with Viman Nagar and surrounding areas including Phoenix Marketcity, Pune Airport, and major hotels, ensuring a smooth and timely pickup and drop-off.',
        },
        {
            question: 'Are airport transfers available from Viman Nagar?',
            answer: 'Yes, we specialize in airport transfers. You can book a cab from Viman Nagar to Pune Airport or Mumbai Airport with timely pickup, luggage assistance, and fixed fares.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Harshad Kamat",
            position: "Software Engineer",
            text: "I booked a Mauli Cab from Viman Nagar to Pune Airport early in the morning. The cab arrived on time and the driver was very professional. Perfect start to my trip!",
            image: "/img/testimonial/testimonial-thumb-1-17.png",
        },
        {
            name: "Miss. Aarti Jadhav",
            position: "College Student",
            text: "Needed a cab from Viman Nagar to my PG in Kothrud late at night. The booking was smooth and I felt safe throughout the ride. Great service from Mauli Cabs!",
            image: "/img/testimonial/testimonial-thumb-1-18.png",
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    









    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7972733209",
            "+91 9763272775",

        ],
        email: "booking@maulicabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Car Rental",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Shirdi Cab Booking",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mahabaleshwar Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala - Khandala Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mumbai Airport Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Pune to Adlabs Imagica Cab Booking ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Best Cab Service For Matheran",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Ganpatipule Cab Booking",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Pandharpur Cab Booking",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Jyotirlinga Tour Package",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Ashtavinayak Darshan Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Best Cab From Pune to Murud Janjira",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Alibaug Affordable Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Ajanta Ellora Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Aurangabad Cab Booking",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Pune to Sade Teen Shakti Peeth Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Pune to Bhimashankar Round Trip",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Pune Trimbakeshwar Best Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Nashik and Igatpuri Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Kolhapur Cab Booking",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Satara Cab Booking",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Tarkarli - Malvan Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Outstation Cab",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Goa Cab Booking",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Tuljapur Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Alandi - Dehu Darshan Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

    const jsonData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Viman Nagar Pune Taxi Service by Mauli Cabs",
        "description": "Mauli Cabs offers top-rated taxi services in Viman Nagar, Pune, including airport pickups and drops, one-way trips to Mumbai and Shirdi, and premium car rentals like Innova. Book your airport or local cab 24x7 with professional drivers.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.9",
          "ratingCount": "5900"
        }
      };
      
    
      
    return (
        <div>
            <GTag/>


<Helmet>
        <title>Viman Nagar Pune Taxi | Mauli Cabs | Call +91 7972733209</title>
        <meta
          name="description"
          content="Book reliable taxi service in Viman Nagar, Pune with Mauli Cabs. Get Innova rentals, airport transfers, and outstation cabs to Mumbai, Shirdi, and more. 24x7 cab bookings available."
        />
        <meta
          name="keywords"
          content="Car Rental Agency in viman nagar Pune, Innova Car Rental in Viman Nagar, Viman nagar taxi service, Taxi Service in Viman Nagar, Best taxi service in viman nagar pune, Best Taxi service in Viman Nagar, pune airport cab, pune to mumbai airport cab, pune to shirdi cab one way, pune to mumbai airport, pune mumbai airport drop, pune airport to shirdi taxi, airport taxi pune, airport drop pune, mumbai international airport to pune cab, pune airport to shirdi cab price, airport cab service pune, airport pickup and drop pune, airport drop mumbai from pune, airport taxi service in pune, best cab service from mumbai airport to pune, airport transfer pune, book airport cab pune, book cab to pune airport, pune airport drop, pune airport cab booking, pune airport drop cab, pune airport drop cab service, pune airport drop charges"
        />
        <script type="application/ld+json">
          {JSON.stringify(jsonData)}
        </script>
      </Helmet>

            <section
                className="vs-breadcrumb"
                style={{ backgroundImage: 'url(/img/bg/breadcrumb-bg-2.png)' }}
            >
                <div className="container">
                    <div className="row text-center">
                        <div className="col-12">
                            <div className="breadcrumb-content">
                                <h1 className="breadcrumb-title">{cardData.keyword}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/64.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mauli Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #631D02',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#631D02' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917972733209" className="d-block  text-white">+91 7972733209</a>
                                                <a href="tel:+919763272775" className="d-block  text-white">+91 9763272775</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:booking@maulicabs.com" className=" text-white d-block">
                                                    booking@maulicabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#631D02' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Mauli Cabs <br />
                                                    Pune Alandi Road , Wadmukkhwadi Charholi Bk, Alandi Devachi , Khed , Pune 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Vimannagarpunetaxi;